/**
 * Country labels for pilot signup (English). Prefers Intl built-ins in modern browsers.
 */

const FALLBACK_COUNTRIES = [
  "United States",
  "United Kingdom",
  "India",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Japan",
  "Singapore",
  "United Arab Emirates",
  "Netherlands",
  "Switzerland",
  "Brazil",
  "Mexico",
  "South Korea",
  "Italy",
  "Spain",
  "Sweden",
  "Norway",
  "Ireland",
  "New Zealand",
  "South Africa",
  "Israel",
  "Saudi Arabia",
  "Malaysia",
  "Philippines",
  "Indonesia",
  "Thailand",
  "Vietnam",
  "Poland",
  "Belgium",
  "Austria",
  "Denmark",
  "Finland",
  "Portugal",
  "Argentina",
  "Chile",
  "Colombia",
  "Egypt",
  "Nigeria",
  "Kenya",
].sort((a, b) => a.localeCompare(b));

export type PilotCountryOption = { value: string; label: string };

/** Sorted unique country names for the pilot signup dropdown. */
export function getPilotCountryOptions(): PilotCountryOption[] {
  try {
    const supported = (
      Intl as unknown as { supportedValuesOf?: (key: "region") => string[] }
    ).supportedValuesOf;
    if (typeof supported !== "function") {
      throw new Error("unsupported");
    }
    const codes = supported.call(Intl, "region").filter((c) => /^[A-Z]{2}$/.test(c) && c !== "ZZ");
    const dn = new Intl.DisplayNames(["en"], { type: "region" });
    const seen = new Set<string>();
    const out: PilotCountryOption[] = [];
    for (const code of codes) {
      const label = dn.of(code);
      if (!label || seen.has(label)) continue;
      seen.add(label);
      out.push({ value: label, label });
    }
    out.sort((a, b) => a.label.localeCompare(b.label));
    return out;
  } catch {
    return FALLBACK_COUNTRIES.map((label) => ({ value: label, label }));
  }
}
